import React from "react";
import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { GetNewMemberRegisterInformationReport } from "../../../../Helpers/APIEndPoints/EndPoints";

const NewMemberRegister = () => {
  return (
    <>
      <MonthlyCommonDashboard
        PageName="NewMemberRegister"
        ExportToExcelUrl={GetNewMemberRegisterInformationReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default NewMemberRegister;
